module.exports = __webpack_public_path__ + "static/media/logo-white.19560fb1.png";